import { presentAppDownloadPromptAtom, type AppDownloadPromptContext, userInfoAtom } from 'app/atoms';
import { hasDownloadedApp } from 'app/lib/user';
import { useAtomValue, useSetAtom } from 'jotai';
import { Platform } from 'react-native';

export function usePresentAppDownloadPrompt() {
  const user = useAtomValue(userInfoAtom);
  const setPrompt = useSetAtom(presentAppDownloadPromptAtom);

  return (prompt: AppDownloadPromptContext) => {
    if (Platform.OS !== 'web' || hasDownloadedApp(user)) return;
    setPrompt(prompt);
  };
}
